<template>
  <v-container fluid class="routeplan-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn @click="runRoutePlansDialog" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Plan
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="routeplans-table"
              show-select
              single-select
              item-key="_id"
              sort-desc
              sort-by="routeplannum"
              :footer-props="footer"
              :headers="headers"
              :items="routeplans"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Route Plan?
                    </v-card-title>
                    <v-card-text>
                      {{ deleterouteplan.routeplannum }} 
                      {{ deleterouteplan.routeplanname }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleterouteplan)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.routeplanimage="{ item }">
                    <v-img
                    v-if="item.routeplanimage" 
                    v-bind:src="item.routeplanimage"
                    max-height="70"
                    max-width="70"
                  ></v-img>
              </template>
              <template v-slot:item.repid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.repid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.repid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.repid!=null && users.length>0 ? users.find(user=>user._id == item.repid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.repid!=null && users.length>0 ? users.find(user=>user._id == item.repid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.loaderid="{ item }">
                <p class="two-line" style="margin-left: 15px;">
                <v-avatar v-if="item.loaderid!=null && users.length>0" size="40">
                  <img v-bind:src="users.find(user=>user._id == item.loaderid)['userimage']" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="40">
                  <p class="two-line"><span class="white--text headline">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'][0].toUpperCase() : '' }}</span></p>
                </v-avatar>
                </p>
                <p class="two-line"><span style="margin-left:15px">{{ item.loaderid!=null && users.length>0 ? users.find(user=>user._id == item.loaderid)['username'] : '' }} </span></p>
              </template>
              <template v-slot:item.daynum="{ item }">
                <p class="two-line" style="font-size: larger; font-weight: 700;">{{ item.daynum  }}</p>
              </template>
              <template v-slot:item.visits="{ item }">
                <p class="two-line">{{ item.visits.length  }}</p>
              </template>
              <template v-slot:item.routeplannum="{ item }">
                <p class="two-line">{{ item.routeplantype  }}</p>
                <p class="two-line">{{ item.routeplannum  }}</p>
                <p class="two-line">{{ new Date(item.routeplandate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ item.locationid!=null && locations.find(location=>location._id == item.locationid)!=null ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }}</p>
                <p class="two-line">{{ item.vehicleid!=null && vehicles.find(vehicle=>vehicle._id == item.vehicleid)!=null ? vehicles.find(vehicle=>vehicle._id == item.vehicleid)['vehiclename'] : '' }}</p>
              </template>
              <template v-slot:item.orderquantity="{ item }">
                {{ item.orderquantity.toLocaleString('en-SG') }}
              </template>
              <template v-slot:item.orderweight="{ item }">
                {{ item.orderweight.toFixed(1) }}
              </template>
              <template v-slot:item.routeplanstatus="{ item }">
                <v-chip
                  small
                  :color="item.routeplanstatus=='New' ? 'primaryConst white--text' :  
                  item.routeplanstatus=='Loaded' ? 'warning white--text' : 
                  item.routeplanstatus=='Unloaded' ? 'greyTint white--text' : 
                  'secondaryConst white--text'">
                  {{ item.routeplanstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isRunPlans"
        persistent
        width="400px"
        max-width="400px"
        >
        <v-card>
          <v-card-title>
            <span class="text-h5">Create Route Plans</span>
          </v-card-title>
            <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <v-select
                    class="mb-4"
                    :items="Array.from({ length: 15 }, (value, index) => index+1)"
                    v-model="new_plans.daynum"
                    placeholder="Day Num"
                    dense
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" md="12">
                  <v-select
                    :items="users.filter(x=>x.userstatus=='Active').map(x => {
                              return {text: x.username, value: x._id};
                            })"
                    v-model="new_plans.repid"
                    label="Sales Rep"
                    required
                  ></v-select>
                </v-col>
                <v-col cols="12" md="12">
                  <v-menu
                          ref="menu_routeplandate"
                          v-model="menu_routeplandate"
                          :close-on-content-click="false"
                          :return-value.sync="new_plans.routeplandate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_plans.routeplandate"
                              label="Loading Date"
                              v-bind="attrs"
                              v-bind:value="new_plans.routeplandate"
                              v-on="on"
                              single-line hint="Please choose the loading date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_plans.routeplandate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_routeplandate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_routeplandate.save(new_plans.routeplandate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                </v-col>
              </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isRunPlans = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="runRoutePlans"
              >
                Save
              </v-btn>
            </v-card-actions>
          
        </v-card>
        </v-dialog>
    </div>
  </v-container>
</template>

<script>
import config from "../../../config";
import { mapState, mapActions } from 'vuex';
import { formatStdDate } from '@/mixins/date';

export default {
  name: 'RoutePlanList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      isRunPlans: false,
      menu_routeplandate: false,
      deleterouteplan: {},
      new_plans: {},
      headers: [
        { text: 'Image', value: 'routeplanimage', width: '7%', sortable: false },
        { text: 'Plan', value: 'routeplannum', width: '10%' },
        { text: 'Day', value: 'daynum', width: '5%' },
        { text: 'Name', value: 'routeplanname', width: '35%' },
        { text: 'Sales Rep', value: 'repid', width: '12%' },
        { text: 'Visits', value: 'visits', width: '5%' },
        { text: 'Status', value: 'routeplanstatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
    }
  },
  computed: {
    ...mapState('RoutePlan', ['routeplans', 'isReceiving', 'isDeleting', 'idToDelete', 'routeplansMessage', 'isUpdating']),
    ...mapState('Location', ['locations']),
    ...mapState('User', ['users']),
    ...mapState('Vehicle', ['vehicles']),
  },
  async created () {
    await this.getRoutePlansRequest();
    console.log(this.routeplans)
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.vehicles.length==0) await this.getVehiclesRequest();
  },
  methods: {
    ...mapActions('Location', ["getLocationsRequest"]),
    ...mapActions('RoutePlan', ["getRoutePlansRequest","deleteRoutePlanRequest","runRoutePlansRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('Vehicle', ["getVehiclesRequest"]),
    editItem(item) {
      this.$router.push({ name: 'RoutePlanEdit', params: item })
    },
    printItem(item) {
      this.$router.push({ name: 'RoutePlanPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'RoutePlanView', params: item })
    },
    deleteItem(item) {
      this.deleteRoutePlanRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleterouteplan = {
        _id: item._id,
        routeplannum: item.routeplannum,
        routeplanname: item.routeplanname,
      }
    },
    runRoutePlansDialog() {
      let date = formatStdDate(new Date());
      this.new_plans = {routeplandate: date};
      this.isRunPlans = true;
    },
    async runRoutePlans(){
      console.log(this.new_plans)
      await this.runRoutePlansRequest(this.new_plans)
      await this.getRoutePlansRequest();
      this.isRunPlans = false;
    }
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
